import React, { Component } from "react";
import { Table, Row, Col } from "reactstrap";
import ResingBenefitTextComponent from "./ResingBenefitTextComponent";
class ResizeBenefitTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      entityType:
        this.props.entityType !== undefined ? this.props.entityType : "vm",
      typeId: this.props.typeID,
    };
  }
  render() {
    const { data } = this.props;
    let DataDiskRecLength = 1;
    Object.keys(data.dataDisk).map((key) => {
      DataDiskRecLength += data.dataDisk[key].length;
    });
    return (
      <div>
        <Row id={`expectedBenefitsDrawbacksImg${this.state.typeId}`}>
          <div className="overviewTextCompParentExpanded">
            {data !== undefined &&
            data.summary.costSummaryText !== undefined &&
            data.summary.costSummaryText !== null ? (
              <div className="maindiv-text-overview maindiv-text-overview-grad">
                <ResingBenefitTextComponent
                  title={data.summary.costSummaryText}
                  data={data.summary.costSummaryDescription}
                />
              </div>
            ) : (
              ""
            )}
            {data !== undefined &&
            data.summary.perfSummaryText !== undefined &&
            data.summary.perfSummaryText !== null ? (
              <div className="maindiv-text-overview maindiv-text-overview-grad">
                <ResingBenefitTextComponent
                  data={data.summary.perfSummaryDescription}
                  title={data.summary.perfSummaryText}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </Row>
        <div className="panel">
          <Row>
            <Col>
              <Table
                className="tableview "
                id={`expectedBenefitsDrawbacks${this.state.typeId}`}
                bordered
              >
                <thead>
                  <tr>
                    <td style={{ borderTop: "0px", borderLeft: "0px" }}></td>
                    <th>Original Spec</th>
                    <th>Recommended Spec</th>
                    <th colSpan="2">Original Limits</th>
                    <th>Recommended Limits</th>
                    <th>Cost Changes</th>
                    <th>Performance Health Changes</th>
                  </tr>
                </thead>
                <tbody>
                  {data.vm.map((key, i) => {
                    let isGPU =
                      data?.gpuDTO && data.gpuDTO.currentGpuNum > 0 ? 2 : 0;
                    return (
                      <>
                        {i === 0 &&
                          data?.gpuDTO &&
                          data.gpuDTO.currentGpuNum > 0 && (
                            <tr>
                              <td id="InnerRow">
                                {" "}
                                <div className={"GpuClass"}> </div>
                                <Col className="tableLeftHead">GPU SM</Col>
                              </td>
                              {i === 0 ? (
                                <td
                                  className="textfield"
                                  rowSpan={
                                    data.vm.length *
                                      (this.state.isAsp ||
                                      this.state.entityType === "db"
                                        ? 4
                                        : 3) +
                                    isGPU
                                  }
                                >
                                  {key.current_vmsize_name}{" "}
                                  {key.hypervgeneration
                                    ? " (" + key.hypervgeneration + ")"
                                    : null}
                                </td>
                              ) : (
                                ""
                              )}
                              {i === 0 ? (
                                <td
                                  className="textfield"
                                  rowspan={
                                    data.vm.length *
                                      (this.state.isAsp ||
                                      this.state.entityType === "db"
                                        ? 4
                                        : 3) +
                                    isGPU
                                  }
                                >
                                  {key.recommended_vmsize_name}{" "}
                                  {key.resize_hypervgeneration
                                    ? " (" + key.resize_hypervgeneration + ")"
                                    : null}
                                </td>
                              ) : (
                                ""
                              )}

                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>
                                      <b>Num vGPU</b>
                                    </td>
                                  </tr>
                                  {/* <tr>
                                    <td>
                                      <b>GPU Speed</b>
                                    </td>
                                  </tr> */}
                                </Table>
                              </td>

                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>{data?.gpuDTO?.currentGpuNum}</td>
                                  </tr>
                                  {/* <tr>
                                    <td>-</td>
                                  </tr> */}
                                </Table>
                              </td>

                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>{data?.gpuDTO?.recommendedGpuNum}</td>
                                  </tr>
                                  {/* <tr>
                                    <td>-</td>
                                  </tr> */}
                                </Table>
                              </td>

                              {i === 0 ? (
                                <td
                                  className="textfield"
                                  rowspan={
                                    data.vm.length *
                                      (this.state.isAsp ||
                                      this.state.entityType === "db"
                                        ? 4
                                        : 3) +
                                    isGPU
                                  }
                                >
                                  {key.cost_change}
                                </td>
                              ) : (
                                ""
                              )}
                              <td className="textfield">
                                {data?.gpuDTO?.gpu_proc_benefit}
                              </td>
                            </tr>
                          )}

                        {i === 0 &&
                          data?.gpuDTO &&
                          data.gpuDTO.currentGpuNum > 0 && (
                            <tr>
                              <td id="InnerRow">
                                {" "}
                                <div className={"GpuMemoryClass"}> </div>
                                <Col className="tableLeftHead">GPU MEMORY</Col>
                              </td>

                              <td className="textfield">
                                <div>
                                  <span className="labelColor">Size</span>
                                </div>
                              </td>

                              <td className="numberfield">
                                {parseFloat(
                                  data?.gpuDTO?.currentPerGpuMemorySizeGB
                                ).toFixed(2)}{" "}
                                GB
                              </td>

                              <td className="numberfield">
                                {parseFloat(
                                  data?.gpuDTO?.recommendedPerGpuMemorySizeGB
                                ).toFixed(2)}{" "}
                                GB
                              </td>

                              <td className="textfield">
                                {data?.gpuDTO?.gpu_mem_benefit}
                              </td>
                            </tr>
                          )}

                        <tr>
                          {i === 0 ? (
                            <td rowSpan={data.vm.length}>
                              <div
                                className={
                                  this.state.entityType === "db"
                                    ? "DbCpuClass"
                                    : "CpuClass"
                                }
                              ></div>
                              <Col className="tableLeftHead">
                                {this.state.entityType === "db"
                                  ? "vCore"
                                  : "CPU"}
                              </Col>
                            </td>
                          ) : (
                            ""
                          )}
                          {i === 0 && !isGPU ? (
                            <td
                              className="textfield"
                              rowSpan={
                                data.vm.length *
                                (this.state.isAsp ||
                                this.state.entityType === "db"
                                  ? 4
                                  : 3)
                              }
                            >
                              {key.current_vmsize_name}
                              {key.hypervgeneration
                                ? " (" + key.hypervgeneration + ")"
                                : null}
                            </td>
                          ) : (
                            ""
                          )}
                          {i === 0 && !isGPU ? (
                            <td
                              className="textfield"
                              rowSpan={
                                data.vm.length *
                                (this.state.isAsp ||
                                this.state.entityType === "db"
                                  ? 4
                                  : 3)
                              }
                            >
                              {key.recommended_vmsize_name}
                              {key.resize_hypervgeneration
                                ? " (" + key.resize_hypervgeneration + ")"
                                : null}
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="textfield">
                            {(() => {
                              switch (this.state.entityType) {
                                case "vm":
                                  return (
                                    <Table>
                                      <tr>
                                        <td>
                                          <b>Num vCPU</b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <b>CPU Speed</b>
                                        </td>
                                      </tr>
                                    </Table>
                                  );
                                  break;
                                case "asp":
                                  return <b>CPU ACUs</b>;
                                  break;
                                case "db":
                                  return <b>Num vCore</b>;
                                  break;
                              }
                            })()}
                          </td>
                          <td className="textfield">
                            {(() => {
                              switch (this.state.entityType) {
                                case "vm":
                                  return (
                                    <Table>
                                      <tr>
                                        <td>{key.current_vcpu}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {parseFloat(
                                            key.current_speed
                                          ).toFixed(2)}{" "}
                                          GHz
                                        </td>
                                      </tr>
                                    </Table>
                                  );
                                  break;
                                case "asp":
                                  return key.current_speed;
                                  break;
                                case "db":
                                  return key.current_vcpu;
                                  break;
                              }
                            })()}
                          </td>
                          <td className="textfield">
                            {(() => {
                              switch (this.state.entityType) {
                                case "vm":
                                  return (
                                    <Table>
                                      <tr>
                                        <td>{key.recommended_vcpu}</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {parseFloat(
                                            key.recommended_speed
                                          ).toFixed(2)}{" "}
                                          GHz
                                        </td>
                                      </tr>
                                    </Table>
                                  );
                                  break;
                                case "asp":
                                  return key.recommended_speed;
                                  break;
                                case "db":
                                  return key.recommended_vcpu;
                                  break;
                              }
                            })()}
                          </td>

                          {i === 0 && !isGPU ? (
                            <td
                              className="textfield"
                              rowSpan={
                                data.vm.length *
                                (this.state.isAsp ||
                                this.state.entityType === "db"
                                  ? 4
                                  : 3)
                              }
                            >
                              {key.cost_change}
                            </td>
                          ) : (
                            ""
                          )}
                          <td className="textfield">{key.vcpu_benefit}</td>
                        </tr>
                      </>
                    );
                  })}

                  {this.state.entityType === "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          <tr>
                            {i === 0 ? (
                              <td rowSpan={data.osdisk.length}>
                                <div className="DbOsClass"></div>
                                <Col className="tableLeftHead">MEMORY</Col>
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="textfield">
                              <Table>
                                <tr>
                                  <td>
                                    <b>Size</b>
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td className="numberfield">
                              <Table>
                                <tr>
                                  <td>{key.current_os_disk_memory} GiB</td>
                                </tr>
                              </Table>
                            </td>
                            <td className="textfield">
                              <Table>
                                <tr>
                                  <td>{key.recommended_os_disk_memory} GiB</td>
                                </tr>
                              </Table>
                            </td>
                            <td className="textfield">{key.os_disk_benefit}</td>
                          </tr>
                        );
                      })
                    : null}

                  {data.vm.map((key, i) => {
                    return (
                      <tr>
                        {i === 0 ? (
                          <td rowSpan={data.vm.length}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbMemoryClass"
                                  : "MemoryClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "DATA DISK"
                                : "MEMORY"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfield">
                          <b>
                            {this.state.entityType === "db" ? "IOPS" : "Size"}
                          </b>
                        </td>
                        <td className="numberfield">{key.current_memory}</td>
                        <td className="textfield">{key.recommended_memory}</td>
                        <td className="textfield">{key.memory_benefit}</td>
                      </tr>
                    );
                  })}
                  {data.vm.map((key, i) => {
                    return (
                      <tr>
                        {i === 0 ? (
                          <td rowSpan={data.vm.length}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbNetworkClass"
                                  : "NetworkClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "LOG DISK"
                                : "NETWORK"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfield">
                          <b>
                            {this.state.entityType === "db"
                              ? "Log Rate"
                              : "Bandwidth"}
                          </b>
                        </td>
                        <td className="numberfield">
                          {key.current_network_bandwidth}
                        </td>
                        <td className="textfield">
                          {key.recommended_network_bandwidth}
                        </td>
                        <td className="textfield">{key.network_benefit}</td>
                      </tr>
                    );
                  })}
                  {this.state.entityType !== "db"
                    ? data.osdisk.map((key, i) => {
                        return (
                          <tr>
                            {i === 0 ? (
                              <td rowSpan={data.osdisk.length}>
                                <div className="OsClass"></div>
                                <Col className="tableLeftHead">
                                  {this.state.isAsp ? "STORAGE" : "OS Disk"}
                                </Col>
                              </td>
                            ) : (
                              ""
                            )}
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {key.current_os_disk_name
                                  ? key.current_os_disk_name.toUpperCase()
                                  : key.current_os_disk_name}
                                {<br />}({key.current_os_disk_tier})
                              </td>
                            )}
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {key.recommended_os_disk_name}
                                {<br />}({key.recommended_os_disk_tier})
                              </td>
                            )}
                            <td className="textfield">
                              {this.state.isAsp ? (
                                <b>Size</b>
                              ) : (
                                <Table>
                                  <tr>
                                    <td>
                                      <b>Throughput</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>IOPS</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>Size</b>
                                    </td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            <td className="textfield">
                              {this.state.isAsp ? (
                                key.current_os_disk_memory
                              ) : (
                                <Table>
                                  <tr>
                                    <td>{key.current_os_disk_bandwidth}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.current_os_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.current_os_disk_memory}</td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            <td className="textfield">
                              {this.state.isAsp ? (
                                key.recommended_os_disk_memory
                              ) : (
                                <Table>
                                  <tr>
                                    <td>{key.recommended_os_disk_bandwidth}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.recommended_os_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>{key.recommended_os_disk_memory}</td>
                                  </tr>
                                </Table>
                              )}
                            </td>
                            {this.state.isAsp ? (
                              ""
                            ) : (
                              <td className="textfield">
                                {key.os_disk_cost_change}
                              </td>
                            )}
                            <td className="textfield">{key.os_disk_benefit}</td>
                          </tr>
                        );
                      })
                    : null}
                  {this.state.entityType !== "db"
                    ? Object.keys(data.dataDisk).map((key) => {
                        return data.dataDisk[key].map((value, i) => {
                          return (
                            <tr>
                              {i === 0 ? (
                                <td
                                  rowSpan={data.dataDisk[key].length}
                                  className="textfield"
                                >
                                  <div className="OsClass"></div>
                                  <Col className="tableLeftHead">
                                    DISK {key}
                                  </Col>{" "}
                                </td>
                              ) : (
                                ""
                              )}
                              <td className="textfield">
                                {value.current_data_disk_name
                                  ? value.current_data_disk_name.toUpperCase()
                                  : value.current_data_disk_name}{" "}
                                {<br />}({value.current_data_disk_tier})
                              </td>
                              <td className="textfield">
                                {value.recommended_data_disk_name.toUpperCase()}{" "}
                                {<br />}({value.recommended_data_disk_tier})
                              </td>
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>
                                      <b>Throughput</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>IOPS</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <b>Size</b>
                                    </td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>{value.current_data_disk_bandwidth}</td>
                                  </tr>
                                  <tr>
                                    <td>{value.current_data_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>{value.current_data_disk_memory}</td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                <Table>
                                  <tr>
                                    <td>
                                      {value.recommended_data_disk_bandwidth}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>{value.recommended_data_disk_iops}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      {value.recommended_data_disk_memory}
                                    </td>
                                  </tr>
                                </Table>
                              </td>
                              <td className="textfield">
                                {" "}
                                {value.data_disk_cost_change}
                              </td>
                              <td className="textfield">
                                {value.data_disk_benefit}
                              </td>
                            </tr>
                          );
                        });
                      })
                    : null}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default ResizeBenefitTable;
